import { getActivePinia } from 'pinia';
import { useChartContextStore } from '@/dashboard/stores/chart-context';
import { useDashboardDetailStore } from '@/dashboard/stores/dashboard-detail';
import { useDashboardLegendStore } from '@/dashboard/stores/dashboard-legend';
import { useDashboardTargetsColorSyncStore } from '@/dashboard/stores/dashboard-targets-color-sync';
import { useDashboardTargetsStore } from '@/dashboard/stores/dashboard-targets';
import { useDashboardViewStore } from '@/dashboard/stores/dashboard-view';
import { useDashboardWidgetsAlertStore } from '@/dashboard/stores/dashboard-widgets-alert';
import { useExternalVariablesStore } from '@/dashboard/stores/global-variables/external-variables';
import { useStandardVariablesStore } from '@/dashboard/stores/global-variables/standard-variables';
import { useTreeVariablesStore } from '@/dashboard/stores/global-variables/tree-variables';
import { useVariablePresetsStore } from '@/dashboard/stores/global-variables/variable-presets';
import { useGlobalFilterStore } from '@/dashboard/stores/global-filter';
import { useGlobalTimePeriodStore } from '@/dashboard/stores/global-time-period';
import { useSeriesColorListStore } from '@/dashboard/stores/series-color-list';
import { useWidgetClickStore } from '@/dashboard/stores/widget-click';
import { useWidgetCustomIdStore } from '@/dashboard/stores/widget-custom-id';
import { useWidgetObserverStore } from '@/dashboard/stores/widget-observer';
import { useWidgetUnitsStore } from '@/dashboard/stores/widget-units';
import { useWidgetUUIDStore } from '@/dashboard/stores/widget-uuid';
import { useDashboardEditUserEnvStore } from '@/dashboard/stores/dashboard-edit-user-env';

const DASHBOARD_SCOPED_STORES = [
  useDashboardViewStore,
  useDashboardDetailStore,
  useDashboardTargetsStore,
  useDashboardWidgetsAlertStore,
  useStandardVariablesStore,
  useExternalVariablesStore,
  useTreeVariablesStore,
  useVariablePresetsStore,
  useGlobalFilterStore,
  useSeriesColorListStore,
  useWidgetCustomIdStore,
  useDashboardTargetsColorSyncStore,
  useDashboardEditUserEnvStore,
  useDashboardLegendStore,
  useWidgetUUIDStore,
  useWidgetUnitsStore,
  useWidgetClickStore,
  useGlobalTimePeriodStore,
  useWidgetObserverStore,
  useChartContextStore,
];

/**
 * 대시보드 라우트 이탈 시 대시보드 스코프 Pinia 스토어들을 dispose합니다.
 * Pinia 공개 API(useXxxStore + $dispose)만 사용합니다.
 */
export const disposeDashboardStores = () => {
  const pinia = getActivePinia();
  if (!pinia) return;

  DASHBOARD_SCOPED_STORES.forEach((useStore) => {
    if (!(useStore.$id in pinia.state.value)) return;
    const store = useStore(pinia);
    store.$dispose();
    delete pinia.state.value[store.$id];
  });
};
